import { render, staticRenderFns } from "./orbit.vue?vue&type=template&id=2e970bbb&"
import script from "./orbit.vue?vue&type=script&lang=js&"
export * from "./orbit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports